import React, { useEffect } from 'react';
import {ThunkDispatch} from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
import {useSelector, useDispatch } from "react-redux";
import Header from '../components/Header';
import LogoHeader from "../components/LogoHeader";
import CustomButton from "../components/CustomButton";
import {currentUserActions} from '../reducers/currentUser'
import i18n from 'i18next';

const NotFoundPage = ({ message = i18n.t('MSG_GLOBAL_PAGE_NOT_FOUND_ERROR'), customRedirectLink = null, isShowSubmitButton = true }: any) => {
    const navigate = useNavigate();
    let redirect_link = "/talent/login";
    const href = window.location.href;
    const origin = window.location.origin;

    const currentUser = useSelector((state: any) => state.currentUser)
    const {superUserInfo, staffInfo, talentInfo} = currentUser

    const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
    useEffect(() => {
        dispatch(currentUserActions.getCurrentUser({navigate, view: ''}))
    }, []);

    if (customRedirectLink) {
        redirect_link = customRedirectLink;
    }
    else {
        if(superUserInfo) redirect_link = "/control/company";
        else if(staffInfo) redirect_link = "/company";
        else if(talentInfo) redirect_link = "/talent";
        else if (href.startsWith(origin + '/control')) redirect_link = "/control/company";
        else if (href.startsWith(origin + '/company')) redirect_link = "/company";
        else if (href.startsWith(origin + '/talent')) redirect_link = "/talent";
    }

    const handleSubmit = (redirect_link: any) => {
        window.location.href = redirect_link
    };
    
    return (
        <div className='static md:fixed md:inset-0 bg-alu-base'>
            <div className='min-w-[100%] md:min-w-[30.625rem] static md:absolute md:top-[141px] left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2'>
                <LogoHeader page="advanced"></LogoHeader>
                <div className="bg-white md:rounded-2xl md:shadow-lg md:max-w-[30.625rem] md:m-auto md:min-h-max min-h-screen w-full py-0 md:py-[24px] md:px-[24px] whitespace-pre-wrap">
                    <div className="block md:hidden">
                        <Header title=""></Header>
                    </div>
                    <div className="hidden md:block">
                        <Header title={message}></Header>
                    </div>
                    <div className={`${isShowSubmitButton ? "" : "md:hidden"} flex flex-col items-center justify-center mt-[3.125rem] md:mt-4 px-4 md:px-6` }>
                        <p className="md:hidden block text-base font-bold alu-text-base-2">
                            {message}
                        </p>
                        {isShowSubmitButton && <CustomButton className="mt-6" type="submit" onClick={() => handleSubmit(redirect_link)}>トップページへ戻る</CustomButton>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;